module.exports = __webpack_public_path__ + "static/media/ECI88_Background.751257f2.png";